// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9e-0";
export var optionCard = "_9e-1";